const UnlockRewardCardContainer = (props) => {
  return (
    <svg
      width="1439"
      height="552"
      viewBox="0 0 1439 552"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M177 82H17C5 80.4 1 90.6667 0.5 96V536.5C0.5 546.5 9.16667 550.667 13.5 551.5H1070C1082.5 551.5 1084.67 550.333 1086 548C1103.67 521.833 1140 467.8 1144 461C1148 454.2 1156 451.5 1159.5 451C1237 451.167 1396.7 451.4 1415.5 451C1434.3 450.6 1438.33 440.167 1438 435V23C1437.2 7 1423.33 1.66667 1416.5 1H255C247 1 241.333 6 239.5 8.5L199 68.5C195.4 80.1 182.833 82.3333 177 82Z"
        stroke="#200052"
      />
    </svg>
  );
};

const LoginBtn = (props) => {
  return (
    <svg
      width="331"
      height="89"
      viewBox="0 0 331 89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M45.4261 9.50007L2.92609 74.5001C-2.67391 86.1001 5.25942 88.3334 9.92609 88H318.426C328.026 85.6 330.426 78.3333 330.426 75V16C330.426 4.4 322.426 1.16671 318.426 1.00007H63.9261C53.1261 0.600066 47.0928 6.50007 45.4261 9.50007Z"
        fill="#200052"
        stroke="#200052"
      />
    </svg>
  );
};

const UnlockRewardArrow = (props) => {
  return (
    <svg
      width="65"
      height="67"
      viewBox="0 0 65 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.8291 21.6471L10.1567 67L0 58.754L44.6895 13.4012L42.6581 11.3397L1.01425 12.369V1.52191e-06H47.735L63.9858 13.3983L65 64.9356H53.8291L54.8461 23.7057L53.8291 21.6471Z"
        fill="#200052"
      />
    </svg>
  );
};

const SquareCard = (props) => {
  return (
    <svg
      className={props.className}
      onClick={props.className}
      width="83"
      height="82"
      viewBox="0 0 83 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.99805 2.28931V12.5391L13.5057 2.28931H2.99805Z"
        fill="#D9D9D9"
      />
      <path
        d="M24.3358 2.28931L2.99805 22.789V32.8454L35.1013 2.28931H24.3358Z"
        fill="#D9D9D9"
      />
      <path
        d="M2.99805 42.8374V53.3451L56.3745 2.28931H45.4801C45.2222 2.28931 17.0513 29.3214 2.99805 42.8374Z"
        fill="#D9D9D9"
      />
      <path
        d="M2.99805 63.4015V73.9092L77.9056 2.28931H67.0112L2.99805 63.4015Z"
        fill="#D9D9D9"
      />
      <path
        d="M6.86591 80.549H17.5025L81.3223 19.3724V9.38039L6.86591 80.549Z"
        fill="#D9D9D9"
      />
      <path
        d="M28.2681 80.549H38.9692L81.2578 39.9365V29.7511L28.2681 80.549Z"
        fill="#D9D9D9"
      />
      <path
        d="M49.2835 80.549H60.2424L81.1933 60.3072V50.1219L49.2835 80.549Z"
        fill="#D9D9D9"
      />
      <path
        d="M70.9435 80.549H81.1933V70.5571L70.9435 80.549Z"
        fill="#D9D9D9"
      />
      <path
        d="M1 19.6947L20.017 1"
        stroke="#FF7700"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M2.54688 39.5497L40.5809 1.51575"
        stroke="#FF7700"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M2.93359 59.6626L61.0804 2.28931"
        stroke="#FF7700"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M3.96582 78.0994L79.7759 3.06287"
        stroke="#FF7700"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M22.4023 80.549L80.5492 27.0436"
        stroke="#FF7700"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M44.4492 80.9358L81.3228 46.6407"
        stroke="#FF7700"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M65.3359 80.9359L81.3231 66.3669"
        stroke="#FF7700"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

const LeaderBoardRewardCard = (props) => {
  return (
    <svg
      className={props.className}
      onMouseMove={props.onMouseMove}
      onClick={props.onClick}
      width="305"
      height="328"
      viewBox="0 0 305 328"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.0003 57.5C2.2003 62.3 3 68 3.0003 73.5C3.00061 79 2 300.7 2 311.5C2 322.3 11 326.667 15.5 327.5H283.5L304 309V10C304 4 299 1.5 296.5 1H56C48.8 1 45.3333 4.66667 44.5 6.5C33.8333 21 11.4001 51.5 7.0003 57.5Z"
        stroke="#200052"
        fillOpacity={0.34}
      />
      <path d="M289 35.5V14.5H268" stroke="#200052" stroke-width="4" />
      <path d="M255 253.5V262.5H264" stroke="#200052" stroke-width="2" />
      <path d="M67 253.5V262.5H58" stroke="#200052" stroke-width="2" />
      <path d="M255 302.5V293.5H264" stroke="#200052" stroke-width="2" />
      <path d="M67 302.5V293.5H58" stroke="#200052" stroke-width="2" />
      <path
        d="M4 1H34.556C37.0177 1 38.4316 3.80145 36.9694 5.7819L6.41347 47.1678C4.69424 49.4964 1 48.2804 1 45.3859V4C1 2.34315 2.34315 1 4 1Z"
        fill="#200052"
        stroke="#200052"
      />
    </svg>
  );
};

const EntrypasssSystemRewardCard = (props) => {
  return (
    <svg
      className={props.className}
      onMouseMove={props.onMouseMove}
      onClick={props.onClick}
      width="307"
      height="328"
      viewBox="0 0 307 328"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M298 57.5C302.8 62.3 302 68 302 73.5C301.999 79 303 300.7 303 311.5C303 322.3 294 326.667 289.5 327.5H21.5L1 309V10C1 4 6 1.5 8.5 1H249C256.2 1 259.667 4.66667 260.5 6.5C271.167 21 293.6 51.5 298 57.5Z"
        stroke="#200052"
      />
      <path d="M262 233.5V242.5H271" stroke="#200052" stroke-width="2" />
      <path d="M53 234.5V243.5H44" stroke="#200052" stroke-width="2" />
      <path d="M262 282.5V273.5H271" stroke="#200052" stroke-width="2" />
      <path d="M53 283.5V274.5H44" stroke="#200052" stroke-width="2" />
      <path d="M17 35.5V14.5H38" stroke="#200052" stroke-width="4" />
      <path
        d="M303.5 1.5H272.944C270.482 1.5 269.068 4.30145 270.531 6.2819L301.087 47.6678C302.806 49.9964 306.5 48.7804 306.5 45.8859V4.5C306.5 2.84315 305.157 1.5 303.5 1.5Z"
        fill="#200052"
        stroke="#200052"
      />
    </svg>
  );
};

const PlayandEarnRewardCard = (props) => {
  return (
    <svg
      className={props.className}
      onMouseMove={props.onMouseMove}
      width="328"
      height="142"
      viewBox="0 0 328 142"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M271 136C266.2 140.8 260.5 140 255 140C249.5 139.999 27.8 141 17 141C6.20001 141 1.83334 132 0.999999 127.5L0.999995 21.5L19.5 1.00001L318.5 1C324.5 1 327 6 327.5 8.5L327.5 87C327.5 94.2 323.833 97.6667 322 98.5C307.5 109.167 277 131.6 271 136Z"
        stroke="#200052"
      />
      <path d="M228 36V45H237" stroke="#200052" stroke-width="2" />
      <path d="M87 36V45H78" stroke="#200052" stroke-width="2" />
      <path d="M228 85V76H237" stroke="#200052" stroke-width="2" />
      <path d="M87 85V76H78" stroke="#200052" stroke-width="2" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M316.422 12.8464L306.344 23L304 21.1539L314.313 11.0003L313.844 10.5387L304.234 10.7692V8H315.016L318.766 10.9996L319 22.5378H316.422L316.657 13.3073L316.422 12.8464Z"
        fill="#200052"
      />
      <path
        d="M324.5 101L274 139.5H287L324.5 112.5V101Z"
        fill="#200052"
        stroke="#200052"
      />
    </svg>
  );
};

const BlazpointsRewardCard = (props) => {
  return (
    <svg
      className={props.className}
      onMouseMove={props.className}
      width="328"
      height="151"
      viewBox="0 0 328 151"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M271 15.0002C266.2 10.2002 260.5 10.9999 255 11.0002C249.5 11.0005 27.8 9.99986 17 9.99986C6.20001 9.99986 1.83334 18.9999 0.999999 23.4999L0.999995 129.5L19.5 150L318.5 150C324.5 150 327 145 327.5 142.5L327.5 63.9999C327.5 56.7999 323.833 53.3332 322 52.4999C307.5 41.8332 277 19.3999 271 15.0002Z"
        stroke="#200052"
      />
      <path d="M32 57.9999V66.9999H23" stroke="#200052" stroke-width="2" />
      <path d="M301 54.9999V63.9999H310" stroke="#200052" stroke-width="2" />
      <path d="M32 107V97.9999H23" stroke="#200052" stroke-width="2" />
      <path d="M301 104V94.9999H310" stroke="#200052" stroke-width="2" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M316.422 141.154L306.344 131L304 132.846L314.313 143L313.844 143.461L304.234 143.231V146H315.016L318.766 143L319 131.462H316.422L316.657 140.693L316.422 141.154Z"
        fill="#200052"
      />
      <path
        d="M274 10.8198L325.141 48.4647L321.487 35.9886L285.037 7.58792L274 10.8198Z"
        fill="#200052"
        stroke="#200052"
      />
    </svg>
  );
};

const StakingPlatformRewardCard = (props) => {
  return (
    <svg
      className={props.className}
      onMouseMove={props.className}
      width="328"
      height="142"
      viewBox="0 0 328 142"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M57.5 136C62.3 140.8 68 140 73.5 140C79 139.999 300.7 141 311.5 141C322.3 141 326.667 132 327.5 127.5L327.5 21.5L309 1.00001L10 1C4.00001 1 1.50001 6 1.00001 8.5L1 87C1 94.2 4.66667 97.6667 6.5 98.5C21 109.167 51.5 131.6 57.5 136Z"
        stroke="#200052"
      />
      <path d="M70 38V47H61" stroke="#200052" stroke-width="2" />
      <path d="M276 38V47H285" stroke="#200052" stroke-width="2" />
      <path d="M70 87V78H61" stroke="#200052" stroke-width="2" />
      <path d="M276 87V78H285" stroke="#200052" stroke-width="2" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5779 12.8464L20.6561 23L23 21.1539L12.6871 11.0003L13.1558 10.5387L22.7659 10.7692V8H11.9842L8.23406 10.9996L8 22.5378H10.5779L10.3432 13.3073L10.5779 12.8464Z"
        fill="#200052"
      />
      <path
        d="M0.999894 100.717L52.7795 137.478L39.7871 137.92L1.39085 112.21L0.999894 100.717Z"
        fill="#200052"
        stroke="#200052"
      />
    </svg>
  );
};

const QuizRewardCard = (props) => {
  return (
    <svg
      className={props.className}
      onMouseMove={props.className}
      width="328"
      height="150"
      viewBox="0 0 328 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M57.5 14.2275C62.3 9.42747 68 10.2272 73.5 10.2275C79 10.2278 300.7 9.22716 311.5 9.22716C322.3 9.22716 326.667 18.2272 327.5 22.7272L327.5 128.727L309 149.227L10 149.227C4.00001 149.227 1.50001 144.227 1.00001 141.727L1 63.2272C1 56.0272 4.66667 52.5605 6.5 51.7272C21 41.0605 51.5 18.6272 57.5 14.2275Z"
        stroke="#200052"
      />
      <path d="M201 54.2271V63.2271H210" stroke="#200052" stroke-width="2" />
      <path d="M143 54.2271V63.2271H134" stroke="#200052" stroke-width="2" />
      <path d="M201 103.227V94.2271H210" stroke="#200052" stroke-width="2" />
      <path d="M143 103.227V94.2271H134" stroke="#200052" stroke-width="2" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5779 140.381L20.6561 130.227L23 132.073L12.6871 142.227L13.1558 142.688L22.7659 142.458V145.227H11.9842L8.23406 142.227L8 130.689H10.5779L10.3432 139.92L10.5779 140.381Z"
        fill="#200052"
      />
      <path
        d="M53.6352 10.958L2.3541 48.4113L6.05421 35.9489L42.6108 7.6848L53.6352 10.958Z"
        fill="#200052"
        stroke="#200052"
      />
    </svg>
  );
};
function StoreFrontCard(props) {
  return (
    <svg
      className={props.className}
      width="490"
      height="642"
      viewBox="0 0 490 642"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 50.764L4.04678 640.823H438.72L489.5 584.966V1L49.7484 3.03118L1 50.764Z"
        stroke="#200052"
      />
    </svg>
  );
}
function StoreFrontItemCard(props) {
  return (
    <svg
      className={props.className}
      width="281"
      height="318"
      viewBox="0 0 281 318"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 29.4309L2.74067 316.541H251.076L280.087 284.628V1L28.8507 2.16045L1 29.4309Z"
        fill="url(#paint0_linear_5408_18)"
        fill-opacity="0.22"
        stroke="#200052"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5408_18"
          x1="140.544"
          y1="1"
          x2="140.544"
          y2="366.541"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#959595" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
function NextItemStoreFrontArrow(props) {
  return (
    <svg
      className={props.className}
      onClick={props.onClick}
      width="42"
      height="26"
      viewBox="0 0 42 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42 13.0875L28.9416 0H21L34.4315 13.0875L21.6396 25.9989C24.0736 25.9519 28.9416 25.8862 28.9416 25.9989C28.9416 26.1116 37.6472 17.4383 42 13.0875Z"
        fill="url(#paint0_linear_5375_9)"
      />
      <path
        d="M21 13.0875L7.94162 0H0L13.4315 13.0875L0.639594 25.9989C3.0736 25.9519 7.94162 25.8862 7.94162 25.9989C7.94162 26.1116 16.6472 17.4383 21 13.0875Z"
        fill="url(#paint1_linear_5375_9)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5375_9"
          x1="42"
          y1="12.9995"
          x2="20.2538"
          y2="12.9995"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5375_9"
          x1="21"
          y1="12.9995"
          x2="-0.746193"
          y2="12.9995"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
}

const StoreFrontLeftArrow = (props) => {
  return (
    <svg
      width="36"
      height="26"
      viewBox="0 0 36 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 13.0875L28.0584 0H36L22.5685 13.0875L35.3604 25.9989C32.9264 25.9519 28.0584 25.8862 28.0584 25.9989C28.0584 26.1116 19.3528 17.4383 15 13.0875Z"
        fill="url(#paint0_linear_5400_9)"
      />
      <path
        d="M0 13.0875L13.0584 0H21L7.56853 13.0875L20.3604 25.9989C17.9264 25.9519 13.0584 25.8862 13.0584 25.9989C13.0584 26.1116 4.35279 17.4383 0 13.0875Z"
        fill="url(#paint1_linear_5400_9)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5400_9"
          x1="15"
          y1="12.9995"
          x2="36.7462"
          y2="12.9995"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7C03" />
          <stop offset="1" stopColor="#FF3300" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5400_9"
          x1="-8.20844e-08"
          y1="12.9995"
          x2="21.7462"
          y2="12.9995"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7C03" />
          <stop offset="1" stopColor="#FF3300" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const StoreFrontRightArrow = (props) => {
  return (
    <svg
      className={props.className}
      onClick={props.onClick}
      width="36"
      height="26"
      viewBox="0 0 36 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 13.0875L7.94162 0H0L13.4315 13.0875L0.639594 25.9989C3.0736 25.9519 7.94162 25.8862 7.94162 25.9989C7.94162 26.1116 16.6472 17.4383 21 13.0875Z"
        fill="url(#paint0_linear_5400_10)"
      />
      <path
        d="M36 13.0875L22.9416 0H15L28.4315 13.0875L15.6396 25.9989C18.0736 25.9519 22.9416 25.8862 22.9416 25.9989C22.9416 26.1116 31.6472 17.4383 36 13.0875Z"
        fill="url(#paint1_linear_5400_10)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5400_10"
          x1="21"
          y1="12.9995"
          x2="-0.746193"
          y2="12.9995"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7C03" />
          <stop offset="1" stopColor="#FF3300" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5400_10"
          x1="36"
          y1="12.9995"
          x2="14.2538"
          y2="12.9995"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7C03" />
          <stop offset="1" stopColor="#FF3300" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const EntrypassSVGContainer = (props) => {
  return (
    <svg
      className={props.className}
      width="1430"
      height="689"
      viewBox="0 0 1430 689"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_5408_6)">
        <path
          d="M16.4997 112.663C3.69969 127.063 1.83302 144.329 2.49968 151.163C1.99979 308.829 1 630.363 1 655.163C3.4 679.963 32 686.496 46 686.663C345.5 687.496 948.3 688.663 963.5 686.663C977.1 688.263 994.5 682.996 1001.5 680.163L1046.5 630.163H1383.5C1422.7 627.763 1430.17 603.829 1429 592.163C1428.67 423.829 1428.2 79.3626 1429 48.1626C1429.8 16.9626 1405.33 4.16259 1393 1.66258C963.333 1.16258 147.4 0.462582 125 1.66258C102.6 2.86258 91.6667 11.8292 89 16.1626C70.1666 42.3292 29.2997 98.2626 16.4997 112.663Z"
          fill="url(#paint0_linear_5408_6)"
          fill-opacity="0.08"
        />
        <path
          d="M16.4997 112.663C3.69969 127.063 1.83302 144.329 2.49968 151.163C1.99979 308.829 1 630.363 1 655.163C3.4 679.963 32 686.496 46 686.663C345.5 687.496 948.3 688.663 963.5 686.663C977.1 688.263 994.5 682.996 1001.5 680.163L1046.5 630.163H1383.5C1422.7 627.763 1430.17 603.829 1429 592.163C1428.67 423.829 1428.2 79.3626 1429 48.1626C1429.8 16.9626 1405.33 4.16259 1393 1.66258C963.333 1.16258 147.4 0.462582 125 1.66258C102.6 2.86258 91.6667 11.8292 89 16.1626C70.1666 42.3292 29.2997 98.2626 16.4997 112.663Z"
          stroke="#200052"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_5408_6"
          x="-9.7"
          y="-9.7"
          width="1449.51"
          height="708.167"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="5.1" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_5408_6"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_5408_6"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_5408_6"
          x1="739.556"
          y1="1"
          x2="739.556"
          y2="687.767"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D9D9D9" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const EntrypassOwnButton = (props) => {
  return (
    <svg
      className={props.className}
      onClick={props.onClick}
      width="267"
      height="73"
      viewBox="0 0 267 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="265"
        height="71"
        fill="url(#paint0_linear_5419_12)"
        fill-opacity="0.04"
      />
      <rect
        x="1.5"
        y="1.5"
        width="264"
        height="70"
        stroke="white"
        stroke-opacity="0.25"
      />
      <path d="M1.5 10.5V1H11" stroke="#FF9900" strokeWidth="2" />
      <path d="M265.5 10.5V1H256" stroke="#FF9900" strokeWidth="2" />
      <path d="M1.5 62V71.5H11" stroke="#FF9900" strokeWidth="2" />
      <path d="M265.5 62V71.5H256" stroke="#FF9900" strokeWidth="2" />
      <defs>
        <linearGradient
          id="paint0_linear_5419_12"
          x1="147.5"
          y1="-32"
          x2="147.5"
          y2="72"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D9D9D9" />
          <stop offset="1" stopColor="#737373" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const EntrypassCard = (props) => {
  return (
    <svg
      width="261"
      height="318"
      viewBox="0 0 261 318"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 29.4309L2.74067 316.541H231.076L260.087 284.628V1L28.8507 2.16045L1 29.4309Z"
        fill="url(#paint0_linear_5436_16)"
        fillOpacity="0.22"
        stroke="#200052"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M250.735 12.1387L237.969 25L235 22.6616L248.063 9.80033L247.469 9.21572L235.296 9.50762V6H248.953L253.704 9.79951L254 24.4146H250.735L251.032 12.7225L250.735 12.1387Z"
        fill="#200052"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5436_16"
          x1="140.544"
          y1="1"
          x2="140.544"
          y2="366.541"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#959595" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const EntrypassDetailsButton = (props) => {
  return (
    <svg
      width="214"
      height="68"
      viewBox="0 0 267 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M1.5 10.5V1H11" stroke="#200052" strokeWidth="2" />
      <path d="M265.5 10.5V1H256" stroke="#200052" strokeWidth="2" />
      <path d="M1.5 62V71.5H11" stroke="#200052" strokeWidth="2" />
      <path d="M265.5 62V71.5H256" stroke="#200052" strokeWidth="2" />
    </svg>
  );
};
const GetMoreNowEntrypassButton = (props) => {
  return (
    <svg
      width="105"
      height="24"
      viewBox="0 0 105 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M97 1H2.5H1V15.5L8.5 23H104V9L97 1Z"
        fill="#200052"
        stroke="#200052"
      />
      <path
        d="M12.944 15.12C12.2 15.12 11.552 14.992 11 14.736C10.448 14.48 9.988 14.136 9.62 13.704C9.26 13.264 8.988 12.776 8.804 12.24C8.628 11.696 8.54 11.14 8.54 10.572C8.54 10.004 8.628 9.448 8.804 8.904C8.988 8.36 9.264 7.872 9.632 7.44C10 7 10.464 6.652 11.024 6.396C11.584 6.132 12.236 6 12.98 6C13.564 6 14.064 6.076 14.48 6.228C14.904 6.372 15.256 6.56 15.536 6.792C15.824 7.024 16.052 7.272 16.22 7.536C16.396 7.792 16.528 8.036 16.616 8.268C16.704 8.5 16.764 8.692 16.796 8.844C16.828 8.988 16.844 9.06 16.844 9.06H15.212C15.212 9.06 15.196 9.008 15.164 8.904C15.14 8.792 15.084 8.656 14.996 8.496C14.908 8.336 14.78 8.176 14.612 8.016C14.452 7.856 14.24 7.724 13.976 7.62C13.712 7.508 13.384 7.452 12.992 7.452C12.52 7.452 12.108 7.54 11.756 7.716C11.412 7.892 11.124 8.128 10.892 8.424C10.66 8.72 10.488 9.052 10.376 9.42C10.264 9.788 10.208 10.164 10.208 10.548C10.208 11.068 10.312 11.568 10.52 12.048C10.728 12.528 11.036 12.92 11.444 13.224C11.86 13.528 12.372 13.68 12.98 13.68C13.684 13.68 14.24 13.488 14.648 13.104C15.064 12.72 15.3 12.208 15.356 11.568H12.932V10.272H16.94V10.932C16.94 11.852 16.764 12.624 16.412 13.248C16.06 13.864 15.58 14.332 14.972 14.652C14.372 14.964 13.696 15.12 12.944 15.12ZM21.273 15.12C20.729 15.12 20.257 15.028 19.857 14.844C19.465 14.652 19.137 14.4 18.873 14.088C18.617 13.768 18.425 13.412 18.297 13.02C18.169 12.628 18.105 12.228 18.105 11.82C18.105 11.412 18.165 11.016 18.285 10.632C18.413 10.24 18.601 9.884 18.849 9.564C19.105 9.244 19.429 8.992 19.821 8.808C20.213 8.616 20.677 8.52 21.213 8.52C21.789 8.52 22.297 8.648 22.737 8.904C23.177 9.16 23.521 9.536 23.769 10.032C24.017 10.52 24.141 11.128 24.141 11.856V12.264H19.713C19.737 12.696 19.885 13.072 20.157 13.392C20.429 13.704 20.801 13.86 21.273 13.86C21.545 13.86 21.769 13.816 21.945 13.728C22.121 13.64 22.257 13.54 22.353 13.428C22.449 13.308 22.517 13.208 22.557 13.128C22.597 13.04 22.617 12.996 22.617 12.996H24.093C24.093 12.996 24.073 13.068 24.033 13.212C23.993 13.348 23.917 13.524 23.805 13.74C23.701 13.948 23.545 14.16 23.337 14.376C23.129 14.584 22.857 14.76 22.521 14.904C22.185 15.048 21.769 15.12 21.273 15.12ZM19.713 11.22H22.605C22.581 10.724 22.433 10.356 22.161 10.116C21.889 9.876 21.569 9.756 21.201 9.756C20.793 9.756 20.453 9.888 20.181 10.152C19.909 10.408 19.753 10.764 19.713 11.22ZM28.2878 15.12C27.8558 15.12 27.4998 15.056 27.2198 14.928C26.9398 14.8 26.7198 14.632 26.5598 14.424C26.4078 14.216 26.2998 13.988 26.2358 13.74C26.1718 13.492 26.1398 13.248 26.1398 13.008V9.924H25.0478V8.64H26.1398V7.056H27.7358V8.64H29.1638V9.924H27.7358V12.972C27.7358 13.54 28.0558 13.824 28.6958 13.824C28.8478 13.824 28.9878 13.816 29.1158 13.8C29.2518 13.776 29.3198 13.764 29.3198 13.764V15.012C29.3198 15.012 29.2158 15.028 29.0078 15.06C28.8078 15.1 28.5678 15.12 28.2878 15.12ZM33.3885 15V8.64H34.9845V9.528H35.0445C35.1245 9.384 35.2365 9.236 35.3805 9.084C35.5245 8.924 35.7085 8.792 35.9325 8.688C36.1645 8.576 36.4485 8.52 36.7845 8.52C37.2565 8.52 37.6445 8.632 37.9485 8.856C38.2525 9.08 38.4765 9.368 38.6205 9.72H38.6445C38.8045 9.416 39.0405 9.14 39.3525 8.892C39.6725 8.644 40.0965 8.52 40.6245 8.52C41.0725 8.52 41.4445 8.624 41.7405 8.832C42.0445 9.032 42.2685 9.304 42.4125 9.648C42.5645 9.992 42.6405 10.364 42.6405 10.764V15H41.0445V11.1C41.0445 10.732 40.9525 10.432 40.7685 10.2C40.5925 9.96 40.3285 9.84 39.9765 9.84C39.6965 9.84 39.4685 9.916 39.2925 10.068C39.1245 10.212 39.0005 10.396 38.9205 10.62C38.8485 10.844 38.8125 11.072 38.8125 11.304V15H37.2165V11.1C37.2165 10.732 37.1285 10.432 36.9525 10.2C36.7765 9.96 36.5085 9.84 36.1485 9.84C35.8685 9.84 35.6405 9.916 35.4645 10.068C35.2965 10.212 35.1725 10.4 35.0925 10.632C35.0205 10.856 34.9845 11.08 34.9845 11.304V15H33.3885ZM47.244 15.12C46.548 15.12 45.956 14.964 45.468 14.652C44.98 14.34 44.608 13.936 44.352 13.44C44.104 12.936 43.98 12.396 43.98 11.82C43.98 11.244 44.104 10.708 44.352 10.212C44.608 9.708 44.98 9.3 45.468 8.988C45.956 8.676 46.548 8.52 47.244 8.52C47.948 8.52 48.54 8.676 49.02 8.988C49.508 9.3 49.876 9.708 50.124 10.212C50.38 10.708 50.508 11.244 50.508 11.82C50.508 12.396 50.38 12.936 50.124 13.44C49.876 13.936 49.508 14.34 49.02 14.652C48.54 14.964 47.948 15.12 47.244 15.12ZM47.244 13.788C47.604 13.788 47.904 13.696 48.144 13.512C48.392 13.328 48.58 13.088 48.708 12.792C48.836 12.488 48.9 12.164 48.9 11.82C48.9 11.468 48.836 11.144 48.708 10.848C48.58 10.552 48.392 10.312 48.144 10.128C47.904 9.944 47.604 9.852 47.244 9.852C46.892 9.852 46.592 9.944 46.344 10.128C46.096 10.312 45.908 10.552 45.78 10.848C45.652 11.144 45.588 11.468 45.588 11.82C45.588 12.164 45.652 12.488 45.78 12.792C45.908 13.088 46.096 13.328 46.344 13.512C46.592 13.696 46.892 13.788 47.244 13.788ZM51.9042 15V8.64H53.4882V9.516H53.5482C53.6602 9.268 53.8442 9.04 54.1002 8.832C54.3562 8.624 54.7402 8.52 55.2522 8.52C55.4122 8.52 55.5442 8.532 55.6482 8.556C55.7522 8.572 55.8042 8.58 55.8042 8.58V10.128C55.8042 10.128 55.7442 10.12 55.6242 10.104C55.5122 10.088 55.3722 10.08 55.2042 10.08C54.6442 10.08 54.2202 10.236 53.9322 10.548C53.6442 10.86 53.5002 11.364 53.5002 12.06V15H51.9042ZM59.6285 15.12C59.0845 15.12 58.6125 15.028 58.2125 14.844C57.8205 14.652 57.4925 14.4 57.2285 14.088C56.9725 13.768 56.7805 13.412 56.6525 13.02C56.5245 12.628 56.4605 12.228 56.4605 11.82C56.4605 11.412 56.5205 11.016 56.6405 10.632C56.7685 10.24 56.9565 9.884 57.2045 9.564C57.4605 9.244 57.7845 8.992 58.1765 8.808C58.5685 8.616 59.0325 8.52 59.5685 8.52C60.1445 8.52 60.6525 8.648 61.0925 8.904C61.5325 9.16 61.8765 9.536 62.1245 10.032C62.3725 10.52 62.4965 11.128 62.4965 11.856V12.264H58.0685C58.0925 12.696 58.2405 13.072 58.5125 13.392C58.7845 13.704 59.1565 13.86 59.6285 13.86C59.9005 13.86 60.1245 13.816 60.3005 13.728C60.4765 13.64 60.6125 13.54 60.7085 13.428C60.8045 13.308 60.8725 13.208 60.9125 13.128C60.9525 13.04 60.9725 12.996 60.9725 12.996H62.4485C62.4485 12.996 62.4285 13.068 62.3885 13.212C62.3485 13.348 62.2725 13.524 62.1605 13.74C62.0565 13.948 61.9005 14.16 61.6925 14.376C61.4845 14.584 61.2125 14.76 60.8765 14.904C60.5405 15.048 60.1245 15.12 59.6285 15.12ZM58.0685 11.22H60.9605C60.9365 10.724 60.7885 10.356 60.5165 10.116C60.2445 9.876 59.9245 9.756 59.5565 9.756C59.1485 9.756 58.8085 9.888 58.5365 10.152C58.2645 10.408 58.1085 10.764 58.0685 11.22ZM66.7781 15V6.12H68.2661L72.3461 12.144V6.12H73.9661V15H72.4781L68.3981 9.084V15H66.7781ZM78.6972 15.12C78.0012 15.12 77.4092 14.964 76.9212 14.652C76.4332 14.34 76.0612 13.936 75.8052 13.44C75.5572 12.936 75.4332 12.396 75.4332 11.82C75.4332 11.244 75.5572 10.708 75.8052 10.212C76.0612 9.708 76.4332 9.3 76.9212 8.988C77.4092 8.676 78.0012 8.52 78.6972 8.52C79.4012 8.52 79.9932 8.676 80.4732 8.988C80.9612 9.3 81.3292 9.708 81.5772 10.212C81.8332 10.708 81.9612 11.244 81.9612 11.82C81.9612 12.396 81.8332 12.936 81.5772 13.44C81.3292 13.936 80.9612 14.34 80.4732 14.652C79.9932 14.964 79.4012 15.12 78.6972 15.12ZM78.6972 13.788C79.0572 13.788 79.3572 13.696 79.5972 13.512C79.8452 13.328 80.0332 13.088 80.1612 12.792C80.2892 12.488 80.3532 12.164 80.3532 11.82C80.3532 11.468 80.2892 11.144 80.1612 10.848C80.0332 10.552 79.8452 10.312 79.5972 10.128C79.3572 9.944 79.0572 9.852 78.6972 9.852C78.3452 9.852 78.0452 9.944 77.7972 10.128C77.5492 10.312 77.3612 10.552 77.2332 10.848C77.1052 11.144 77.0412 11.468 77.0412 11.82C77.0412 12.164 77.1052 12.488 77.2332 12.792C77.3612 13.088 77.5492 13.328 77.7972 13.512C78.0452 13.696 78.3452 13.788 78.6972 13.788ZM84.6363 15L82.6443 8.64H84.2403L85.5123 13.008L86.8683 8.64H88.3203L89.6763 13.008L90.9483 8.64H92.5443L90.5403 15H88.8483L87.6003 10.956L86.3403 15H84.6363Z"
        fill="white"
      />
    </svg>
  );
};

const TestnetEntrypassButton = (props) => {
  return (
    <svg
      width="73"
      height="21"
      viewBox="0 0 73 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.0327 13.1792L19.0227 8.2492H16.4227V7.2892H22.9627V8.2492H20.3527V13.1792H19.0327ZM24.5856 13.1792C24.2523 13.1792 23.9956 13.1359 23.8156 13.0492C23.6356 12.9625 23.5056 12.8525 23.4256 12.7192C23.3523 12.5859 23.3056 12.4459 23.2856 12.2992C23.2723 12.1525 23.2656 12.0192 23.2656 11.8992V9.9792C23.2656 9.8792 23.2723 9.7592 23.2856 9.6192C23.3056 9.47253 23.3523 9.3292 23.4256 9.1892C23.5056 9.0492 23.6356 8.93253 23.8156 8.8392C24.0023 8.74587 24.259 8.6992 24.5856 8.6992H26.7356C27.1756 8.6992 27.519 8.74253 27.7656 8.8292C28.019 8.9092 28.1956 9.04253 28.2956 9.2292C28.4023 9.41587 28.4556 9.66587 28.4556 9.9792V11.4592H26.7056C26.1056 11.4592 25.6156 11.4459 25.2356 11.4192C24.8623 11.3925 24.6123 11.3759 24.4856 11.3692V11.9192C24.479 12.1859 24.639 12.3192 24.9656 12.3192H25.4756C25.8356 12.3192 26.1856 12.3159 26.5256 12.3092C26.8723 12.2959 27.189 12.2825 27.4756 12.2692C27.7623 12.2492 27.9923 12.2325 28.1656 12.2192L28.5656 12.8692C28.5656 13.0759 27.909 13.1792 26.5956 13.1792H24.5856ZM24.4856 10.5992H27.2356V9.9592C27.2356 9.82587 27.219 9.73253 27.1856 9.6792C27.159 9.62587 27.0723 9.59253 26.9256 9.5792C26.779 9.56587 26.529 9.5592 26.1756 9.5592H24.9656C24.6456 9.5592 24.4856 9.69253 24.4856 9.9592V10.5992ZM30.6968 13.1792C30.2501 13.1792 29.9335 13.1559 29.7468 13.1092C29.5601 13.0625 29.4668 13.0159 29.4668 12.9692L29.7668 12.2192C29.9601 12.2392 30.3135 12.2625 30.8268 12.2892C31.3468 12.3092 31.9868 12.3192 32.7468 12.3192H33.2468C33.4135 12.3192 33.5168 12.2759 33.5568 12.1892C33.6035 12.0959 33.6268 11.9725 33.6268 11.8192C33.6268 11.6659 33.6001 11.5425 33.5468 11.4492C33.5001 11.3559 33.4001 11.3092 33.2468 11.3092H30.7868C30.3201 11.3092 29.9835 11.2225 29.7768 11.0492C29.5701 10.8692 29.4668 10.6025 29.4668 10.2492V9.8492C29.4668 9.75587 29.4768 9.64587 29.4968 9.5192C29.5168 9.39253 29.5668 9.26587 29.6468 9.1392C29.7268 9.01253 29.8568 8.9092 30.0368 8.8292C30.2168 8.74253 30.4668 8.6992 30.7868 8.6992H33.5468C33.9468 8.6992 34.2301 8.72253 34.3968 8.7692C34.5635 8.81587 34.6468 8.86253 34.6468 8.9092L34.5468 9.6592C34.3535 9.6392 33.9968 9.6192 33.4768 9.5992C32.9568 9.57253 32.3201 9.5592 31.5668 9.5592H31.0668C30.9001 9.5592 30.7935 9.60587 30.7468 9.6992C30.7068 9.78587 30.6868 9.8892 30.6868 10.0092C30.6868 10.1359 30.7068 10.2425 30.7468 10.3292C30.7935 10.4092 30.9001 10.4492 31.0668 10.4492H33.5268C33.9801 10.4492 34.3135 10.5425 34.5268 10.7292C34.7401 10.9159 34.8468 11.1525 34.8468 11.4392V12.0292C34.8468 12.1492 34.8368 12.2759 34.8168 12.4092C34.8035 12.5425 34.7568 12.6692 34.6768 12.7892C34.5968 12.9025 34.4668 12.9959 34.2868 13.0692C34.1068 13.1425 33.8535 13.1792 33.5268 13.1792H30.6968ZM37.6838 13.1792C37.1771 13.1792 36.8304 13.0725 36.6438 12.8592C36.4571 12.6459 36.3638 12.3259 36.3638 11.8992V9.5592H35.5438V8.6992H35.9638C36.0904 8.6992 36.1804 8.6792 36.2338 8.6392C36.2938 8.5992 36.3371 8.5192 36.3638 8.3992L36.5638 7.3292H37.5838V8.6992H39.6638V9.5592H37.5838V11.9092C37.5838 12.0759 37.6238 12.1859 37.7038 12.2392C37.7838 12.2925 37.9038 12.3192 38.0638 12.3192H39.4738L39.5738 13.0792C39.4338 13.0992 39.2204 13.1225 38.9338 13.1492C38.6471 13.1692 38.3338 13.1792 37.9938 13.1792H37.6838ZM40.4652 13.1792V8.6992H41.2852L41.6852 8.8992C41.9652 8.84587 42.3019 8.7992 42.6952 8.7592C43.0886 8.7192 43.5386 8.6992 44.0452 8.6992H44.5452C44.8786 8.6992 45.1352 8.74587 45.3152 8.8392C45.4952 8.93253 45.6219 9.0492 45.6952 9.1892C45.7752 9.3292 45.8219 9.47253 45.8352 9.6192C45.8552 9.7592 45.8652 9.8792 45.8652 9.9792V13.1792H44.6452V9.9592C44.6452 9.69253 44.4852 9.5592 44.1652 9.5592H41.9852C41.8586 9.5592 41.7752 9.57253 41.7352 9.5992C41.7019 9.6192 41.6852 9.6792 41.6852 9.7792V13.1792H40.4652ZM48.238 13.1792C47.9046 13.1792 47.648 13.1359 47.468 13.0492C47.288 12.9625 47.158 12.8525 47.078 12.7192C47.0046 12.5859 46.958 12.4459 46.938 12.2992C46.9246 12.1525 46.918 12.0192 46.918 11.8992V9.9792C46.918 9.8792 46.9246 9.7592 46.938 9.6192C46.958 9.47253 47.0046 9.3292 47.078 9.1892C47.158 9.0492 47.288 8.93253 47.468 8.8392C47.6546 8.74587 47.9113 8.6992 48.238 8.6992H50.388C50.828 8.6992 51.1713 8.74253 51.418 8.8292C51.6713 8.9092 51.848 9.04253 51.948 9.2292C52.0546 9.41587 52.108 9.66587 52.108 9.9792V11.4592H50.358C49.758 11.4592 49.268 11.4459 48.888 11.4192C48.5146 11.3925 48.2646 11.3759 48.138 11.3692V11.9192C48.1313 12.1859 48.2913 12.3192 48.618 12.3192H49.128C49.488 12.3192 49.838 12.3159 50.178 12.3092C50.5246 12.2959 50.8413 12.2825 51.128 12.2692C51.4146 12.2492 51.6446 12.2325 51.818 12.2192L52.218 12.8692C52.218 13.0759 51.5613 13.1792 50.248 13.1792H48.238ZM48.138 10.5992H50.888V9.9592C50.888 9.82587 50.8713 9.73253 50.838 9.6792C50.8113 9.62587 50.7246 9.59253 50.578 9.5792C50.4313 9.56587 50.1813 9.5592 49.828 9.5592H48.618C48.298 9.5592 48.138 9.69253 48.138 9.9592V10.5992ZM54.9591 13.1792C54.4525 13.1792 54.1058 13.0725 53.9191 12.8592C53.7325 12.6459 53.6391 12.3259 53.6391 11.8992V9.5592H52.8191V8.6992H53.2391C53.3658 8.6992 53.4558 8.6792 53.5091 8.6392C53.5691 8.5992 53.6125 8.5192 53.6391 8.3992L53.8391 7.3292H54.8591V8.6992H56.9391V9.5592H54.8591V11.9092C54.8591 12.0759 54.8991 12.1859 54.9791 12.2392C55.0591 12.2925 55.1791 12.3192 55.3391 12.3192H56.7491L56.8491 13.0792C56.7091 13.0992 56.4958 13.1225 56.2091 13.1492C55.9225 13.1692 55.6091 13.1792 55.2691 13.1792H54.9591Z"
        fill="white"
      />
      <rect
        x="1"
        y="1"
        width="71.1754"
        height="19.0696"
        fill="url(#paint0_linear_5439_23)"
        fillOpacity="0.04"
      />
      <rect
        x="1.5"
        y="1.5"
        width="70.1754"
        height="18.0696"
        stroke="white"
        strokeOpacity="0.25"
      />
      <path d="M1.13477 3.55157V1H3.68634" stroke="#FF9900" strokeWidth="2" />
      <path d="M71.7715 3.55157V1H69.2199" stroke="#FF9900" strokeWidth="2" />
      <path
        d="M1.13477 17.384V19.9355H3.68634"
        stroke="#FF9900"
        strokeWidth="2"
      />
      <path
        d="M71.7715 17.384V19.9355H69.2199"
        stroke="#FF9900"
        strokeWidth="2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5439_23"
          x1="40.3479"
          y1="-7.86336"
          x2="40.3479"
          y2="20.0696"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D9D9D9" />
          <stop offset="1" stopColor="#737373" />
        </linearGradient>
      </defs>
    </svg>
  );
};
const LeaderboardArrow = (props) => {
  return (
    <svg
      width="21"
      height="26"
      viewBox="0 0 21 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 13.0875L7.94162 0H0L13.4315 13.0875L0.639594 25.9989C3.0736 25.9519 7.94162 25.8862 7.94162 25.9989C7.94162 26.1116 16.6472 17.4383 21 13.0875Z"
        fill="url(#paint0_linear_5326_227)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5326_227"
          x1="21"
          y1="12.9995"
          x2="-0.746193"
          y2="12.9995"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7C03" />
          <stop offset="1" stopColor="#FF3300" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const LeaderboardStars = (props) => {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.65953 2.34931C7.99304 1.50665 9.18566 1.50665 9.51917 2.3493L10.3669 4.49118C10.5179 4.87262 10.8865 5.12317 11.2967 5.12317H13.55C14.5656 5.12317 14.9345 6.46175 14.0622 6.982L12.6009 7.85366C12.1797 8.10488 12.0028 8.62448 12.1833 9.08049L12.8166 10.6808C13.1679 11.5684 12.1944 12.3966 11.3746 11.9076L9.1016 10.5519C8.78603 10.3637 8.39266 10.3637 8.0771 10.5519L5.80414 11.9076C4.98427 12.3966 4.01075 11.5684 4.36207 10.6807L4.99542 9.0805C5.17591 8.62448 4.99906 8.10488 4.57786 7.85365L3.11647 6.982C2.24424 6.46176 2.61313 5.12317 3.62873 5.12317H5.88199C6.29222 5.12317 6.66084 4.87262 6.81181 4.49118L7.65953 2.34931Z"
        stroke="#200052"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export {
  LoginBtn,
  UnlockRewardCardContainer,
  UnlockRewardArrow,
  SquareCard,
  LeaderBoardRewardCard,
  EntrypasssSystemRewardCard,
  PlayandEarnRewardCard,
  BlazpointsRewardCard,
  StakingPlatformRewardCard,
  QuizRewardCard,
  StoreFrontCard,
  StoreFrontItemCard,
  NextItemStoreFrontArrow,
  StoreFrontLeftArrow,
  StoreFrontRightArrow,
  EntrypassSVGContainer,
  EntrypassOwnButton,
  EntrypassCard,
  EntrypassDetailsButton,
  GetMoreNowEntrypassButton,
  TestnetEntrypassButton,
  LeaderboardArrow,
  LeaderboardStars,
};
